export default "__VITE_ASSET__588a00bb__"